<template>
  <v-row>
    <v-dialog v-model="dialog" persistent width="600px" scrollable>
      <v-card height="auto" v-if="dialog">
        <v-card-title
          class="text-h6 text-uppercase black--text font-weight-bold"
        >
          <v-spacer></v-spacer>
          <div>Nego Harga</div>
          <v-spacer></v-spacer>
          <v-btn text small color="pink" @click="hideDialog" class="mr-n3">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12"> 
              <template v-if="data.length > 0">
                <v-row v-for="(form, i) in data" :key="i" class="px-3">
                  <!-- <pre>{{ form }}</pre> -->
                  <v-col cols="12">
                    <div class="text-h6 font-weight-bold">
                      {{ form.trx_detail_product_name }}
                    </div>
                    <div class="text-body-2">
                      Harga Asli: {{ form.trx_detail_product_price | toNumber }}
                    </div>
                    <div class="text-body-2">
                      Harga Nego {{ form.trx_detail_nego_is_seller == '1' ? 'Ditawarkan' : 'Diajukan' }}: {{ form.trx_detail_price_nego | toNumber }}
                    </div>
                  </v-col>
                  <v-col v-if="form.trx_detail_status_nego == 'submitted'" cols="12">
                    <v-form v-model="valid" ref="formNego" role="form">
                      <label class="text-body-2 font-weight-bold"
                        >Harga Nego Diajukan</label
                      >
                      <div class="d-flex">
                        <v-currency-field
                          v-model="form.trx_detail_price_nego_seller"
                          outlined
                          dense
                          validate-on-blur
                          :disabled="  
                            form.trx_detail_nego_is_member == '1'
                          "
                          hide-details
                          :max="form.trx_detail_price"
                          placeholder="Masukkan Harga Yang Diinginkan"
                          class="rounded-lg text-body-2"
                        ></v-currency-field>
                        <!-- <v-btn
                          v-if="form.trx_detail_nego_is_member == '1'"
                          text
                          color="warning"
                          :disabled="checkTrxNegoUpdatedMembe"
                          class="text-capitalize mr-2"
                          @click="form.trx_detail_status_nego = ''"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn> -->
                      </div>
                      <template v-if="form.trx_detail_price_nego_seller !== 0">
                        <!-- <small
                          class="text-danger"
                          v-if="form.trx_detail_price_nego_seller < form.min_price_nego"
                          >Harga nego tidak boleh lebih rendah dari harga minimal
                          nego
                        </small> -->
                        <small
                          class="text-danger red--text"
                          v-if="
                            form.trx_detail_price_nego_seller >
                            form.trx_detail_product_price
                          "
                          >Nilai melebihi harga produk</small
                        >
                      </template>
                    </v-form>
                  </v-col>
                  <v-col cols="12">
                    <div class="d-flex justify-end">
                      <!-- <v-btn
                        color="primary"
                        :disabled="form.trx_detail_nego_is_member == '1'"
                        :outlined="form.trx_detail_status_nego !== 'submitted'"
                        class="text-capitalize mr-2"
                        @click="ajukanNego(i)"
                      >
                        Ajukan Harga Nego
                      </v-btn> -->
                      <v-radio-group
                        :disabled="form.trx_detail_nego_is_member == '1'"
                        v-model="form.trx_detail_status_nego"
                        row
                      >
                        <v-radio label="Ajukan Harga Lain"  value="submitted"></v-radio>
                        <v-radio label="Setujui" value="approved"></v-radio>
                        <v-radio label="Tolak" value="rejected"></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <!-- <v-card elevation="0" class="rounded-lg"> -->
              <v-row
                v-if="false"
                v-for="(form, i) in data"
                :key="i"
                class="px-3"
              >
                <v-col cols="12">
                  <div class="text-h6 font-weight-bold">
                    {{ form.product_name }}
                  </div>
                  <div class="text-body-2">
                    Harga : {{ form.cart_detail_price | toNumber }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-form v-model="valid" ref="formNego" role="form">
                    <label class="text-body-2 font-weight-bold"
                      >Harga Nego</label
                    >
                    <v-currency-field
                      v-model="form.cart_detail_price_nego"
                      outlined
                      dense
                      validate-on-blur
                      hide-details
                      :max="form.subtotal"
                      placeholder="Masukkan Harga Yang Diinginkan"
                      class="rounded-lg text-body-2"
                    ></v-currency-field>
                    <template v-if="form.cart_detail_price_nego !== 0">
                      <small
                        class="text-danger"
                        v-if="form.cart_detail_price_nego < form.min_price_nego"
                        >Harga nego tidak boleh lebih rendah dari harga minimal
                        nego
                      </small>
                      <small
                        class="text-danger"
                        v-if="
                          form.cart_detail_price_nego > form.cart_detail_price
                        "
                        >Nilai melebihi harga produk</small
                      >
                    </template>
                  </v-form>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex justify-end">
                    <!-- <v-btn :loading="loadingProcess" class="white--text mr-2" color="red" @click="batalkanNego(i)">Batal
											Nego</v-btn>
										<v-btn :loading="loadingProcess" class="white--text" color="blue" @click="ajukanNego(i)">Ajukan
											Nego</v-btn> -->
                  </div>
                </v-col>
              </v-row>
              <!-- </v-card> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                :disabled="checkTrxNegoUpdatedMember == data.length"
                color="primary"
                @click="saveNego"
                class="text-capitalize"
              >
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  // {
  //       product_name,
  //       min_price_nego,
  //       cart_detail_id,
  //       cart_detail_product_id,
  //       cart_detail_price:subtotal,
  //       cart_detail_price_nego:0
  //   }
  data() {
    return {
      valid: false,
      loadingProcess: false,
      rules: [
        (v) =>
          v < this.data.min_price_nego ||
          "Nilai kurang dari harga minimum nego",
        (v) => v > this.data.subtotal || "Nilai melebihi harga produk",
      ],
      headers: [
        {
          text: "Info Pesanan",
          align: "start",
          sortable: false,
          value: "product_name",
        },
      ],
    };
  },
  props: {
    value: Boolean,
    data: Array,
    trx_id: String,
    varian_selected: Object,
  },
  methods: {
    hideDialog() {
      // this.$emit('hideDialog')
      this.dialog = false;
      this.loadingProcess = false;
      // this.$store.commit("cart/resetResponseError");
    },
    ajukanNego(i) {
      this.data[i].trx_detail_status_nego = "submitted";
    },
    saveNego() {
      let inputForm = this.data.map((i) => {
        const {
          trx_detail_id,
          trx_detail_product_id,
          trx_detail_product_name,
          trx_detail_product_price,
          trx_detail_price_nego,
          trx_detail_price_nego_seller,
          trx_detail_status_nego,
          trx_detail_nego_is_member,
          trx_detail_nego_is_seller,
        } = i;
        if(trx_detail_nego_is_member == '1' && trx_detail_status_nego !== 'submitted'){
          return {
          trx_detail_id,
          trx_detail_product_id,
          trx_detail_product_name,
          trx_detail_product_price,
          trx_detail_status_nego,
          trx_detail_price_nego,
          trx_detail_nego_is_member,
          trx_detail_nego_is_seller,
        };
        }else{
          return {
            trx_detail_id,
            trx_detail_product_id,
            trx_detail_product_name,
            trx_detail_product_price,
            trx_detail_status_nego,
            trx_detail_price_nego:
              trx_detail_status_nego == "submitted"
                ? trx_detail_price_nego_seller
                : trx_detail_price_nego,
            trx_detail_nego_is_member: "1",
            trx_detail_nego_is_seller: "0",
          }; 
        }
      }); 
      try {
        this.data.forEach((i) => {
          if (i.trx_detail_price_nego_seller > i.trx_detail_product_price) {
            throw new Error(
              `Nilai melebihi harga produk ${i.trx_detail_product_name}`
            );
          }
        });

        this.$store
          .dispatch("transaction/updateHargaNego", {
            trx_id: this.trx_id,
            trx_nego_items: inputForm,
          })
          .then(() => {
            this.$store.commit(
              "makeAlert",
              {
                code: "success",
                type: "success",
                message: "Berhasil mengubah transaksi nego",
                show: true,
              },
              { root: true }
            );
            this.$emit("updateData");
            this.hideDialog();
          });
      } catch (error) {
        this.$store.commit(
          "makeAlert",
          {
            code: "error",
            type: "error",
            message: error,
            show: true,
          },
          { root: true }
        );
      }
    },
  },
  watch: {
    responseError: {
      handler(val) {
        if (val.cart_detail_price_nego) {
          this.loadingProcess = false;
          this.$store.commit(
            "makeAlert",
            {
              code: "error",
              type: "error",
              message: val.cart_detail_price_nego.message,
              show: true,
            },
            { root: true }
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    checkTrxNegoUpdatedMember() {
      let negoCount = this.data.filter((i) => i.trx_detail_nego_is_member == "1");
      return negoCount.length;
    },
    ...mapState("cart", ["responseError"]),
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
